import { render, staticRenderFns } from "./MessageAdmin.vue?vue&type=template&id=08ad8130&scoped=true&"
import script from "./MessageAdmin.vue?vue&type=script&lang=js&"
export * from "./MessageAdmin.vue?vue&type=script&lang=js&"
import style0 from "./MessageAdmin.vue?vue&type=style&index=0&id=08ad8130&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ad8130",
  null
  
)

export default component.exports